import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./components/dashboard/Dashboard";
import UserList from "./components/user/UserList";
import UserDetail from "./components/user/UserDetail";
import ChangePassword from "./components/user/ChangePassword";
import Login from "./components/login/Login";
import CategoryList from "./components/category/CategoryList";
import CategoryDetail from "./components/category/CategoryDetail";
import BrandDetail from "./components/brand/BrandDetail";
import BrandList from "./components/brand/BrandList";
import UnitList from "./components/unit/UnitList";
import UnitDetail from "./components/unit/UnitDetail";
import ProductGroupList from "./components/product-group/ProductGroupList";
import ProductGroupDetail from "./components/product-group/ProductGroupDetail";
import WarehouseDetail from "./components/warehouse/WarehouseDetail";
import WarehouseList from "./components/warehouse/WarehouseList";
import ProductDetail from "./components/product/ProductDetail";
import ProductList from "./components/product/ProductList";
import StockTransferDetail from "./components/stock-transfer/StockTransferDetail";
import StockTransferList from "./components/stock-transfer/StockTransferList";
import StockInDetail from "./components/stockin/StockInDetail";
import StockInList from "./components/stockin/StockInList";
import TaxList from "./components/tax/TaxList";
import TaxDetailList from "./components/tax/TaxDetail";
import StockAdjustmentList from "./components/stock-adjustment/StockAdjustmentList";
import StockAdjustmentDetail from "./components/stock-adjustment/StockAdjustmentDetail";
import CounterCashList from "./components/counter-cash/CounterCashList";
import CheckList from "./components/check-list/CheckList";
import MaintenanceScheduleList from "./components/maintenance-schedule/MaintenanceScheduleList";
import CounterCashDetail from "./components/counter-cash/CounterCashDetail";
import StockTakeList from "./components/stock-take/StockTakeList";
import StockTakeRegister from "./components/stock-take/StockTakeRegister";
import StockBalanceList from "./components/stock-balance/StockBalanceList";
import CounterCashReport from "./components/counter-cash/CounterCashReport";
import SystemSerializeList from "./components/system-serialize/SystemSerializeList";
import SystemSerializeDetail from "./components/system-serialize/SystemSerializeDetail";
import CashInHandReport from "./components/cash-in-hand/CashInHandReport";
import PreventiveMaintenanceMachineReport from "./components/preventive-maintenance-machine/PreventiveMaintenanceMachineReport";
import SaleReport from "./components/sale-report/SaleReport";
import PurchaseAnalysisReport from "./components/purchase-order-report/PurchaseAnalysisReport";
import PurchaseOrderReport from "./components/purchase-order-report/PurchaseOrderReport";
import StockTransferReport from "./components/stock-transfer-report/StockTransferReport";
import DamageSaleApprovedReport from "./components/damage-sale-report/DamageSaleApprovedReport";
import DamageSaleNotApprovedReport from "./components/damage-sale-report/DamageSaleNotApprovedReport";
import MenuReport from "./components/menu-report/MenuReport";
import CustomerCreditBalanceList from "./components/customer-credit-balance/CustomerCreditBalanceList";
import StockValuationReport from "./components/stock-valuation-report/StockValuationReport";

import ShiftInfoList from "./components/shift-info/ShiftInfoList";
import ShiftInfoDetail from "./components/shift-info/ShiftInfoDetail";
import ShiftAssignList from "./components/shift-assign/ShiftAssignList";
import ShiftAssignDetail from "./components/shift-assign/ShiftAssignDetail";
import ShopList from "./components/shop/ShopList";
import ShopDetail from "./components/shop/ShopDetail";
import LetterHeadList from "./components/letter-head/LetterHeadList";
import LetterHeadDetail from "./components/letter-head/LetterHeadDetail";
import CounterList from "./components/counter/CounterList";
import CounterDetail from "./components/counter/CounterDetail";
import CurrencyList from "./components/currency/CurrencyList";
import CurrencyDetail from "./components/currency/CurrencyDetail";
import CurrencyExchangeList from "./components/currency-exchange-rate/CurrencyExchangeList";
import CurrencyExchangeDetail from "./components/currency-exchange-rate/CurrencyExchangeDetail";

import SaleList from "./components/sale/SaleList";
import CreditLevelDetail from "./components/credit-level/CreditLevelDetail";
import CreditLevelList from "./components/credit-level/CreditLevelList";
import CustomerDetail from "./components/customer/CustomerDetail";
import CustomerList from "./components/customer/CustomerList";

import ProductionItemDetail from "./components/production-item/ProductionItemDetail";
import ProductionItemList from "./components/production-item/ProductionItemList";

import PurchaseOrderList from "./components/purchase-order/PurchaseOrderList";
import PurchaseOrderDetail from "./components/purchase-order/PurchaseOrderDetail";
import PurchaseOrderOrder from "./components/purchase-order/PurchaseOrderOrder";
import PurchaseOrderAssetList from "./components/purchase-order-asset/PurchaseOrderAssetList";
import PurchaseOrderAssetDetail from "./components/purchase-order-asset/PurchaseOrderAssetDetail";

import PriceModelList from "./components/price-model/PriceModelList";
import PriceModelDetail from "./components/price-model/PriceModelDetail";

import SupplierList from "./components/supplier/SupplierList";
import SupplierDetail from "./components/supplier/SupplierDetail";

import SaleReturn from "./components/sale-return/SaleReturn";

import WholeSaleList from "./components/whole-sale/WholeSaleList";
import WholeSaleDetail from "./components/whole-sale/WholeSaleDetail";
import CreditCashFlowList from "./components/credit-cash-flow/CreditCashFlowList";

import StockIssueList from "./components/stock-issue/StockIssueList";
import StockIssueDetail from "./components/stock-issue/StockIssueDetail";

import CityList from "./components/city-township/CityList";
import CityDetail from "./components/city-township/CityDetail";

import CustomerShopList from "./components/customer-shop/CustomerShopList";
import CustomerShopDetail from "./components/customer-shop/CustomerShopDetail";

import WayAssignList from "./components/way-assign/WayAssignList";
import WayAssignDetail from "./components/way-assign/WayAssignDetail";

import WaySaleReport from "./components/sale-report/WaySaleReport";
import WayList from "./components/way/WayList";
import WayDetail from "./components/way/WayDetail";

import MaterialSessionList from "./components/material-session/MaterialSessionList";
import MaterialSessionDetail from "./components/material-session/MaterialSessionDetail";

import StockTemplateList from "./components/stock-template/StockTemplateList";
import StockTemplateDetail from "./components/stock-template/StockTemplateDetail";

import CheckInReport from "./components/check-in-report/CheckInReport";

import ShopTypeList from "./components/shop-type/ShopTypeList";
import ShopTypeDetail from "./components/shop-type/ShopTypeDetail";

import BinTypeList from "./components/bin-type/BinTypeList";
import BinTypeDetail from "./components/bin-type/BinTypeDetail";
import BinList from "./components/bin/BinList";
import BranchDetail from "./components/branch/BranchDetail";
import BranchList from "./components/branch/BranchList";
import BinDetail from "./components/bin/BinDetail";
import OrderList from "./components/order/OrderList";
import OrderDetail from "./components/order/OrderDetail";
import RegionList from "./components/region/RegionList";
import RegionDetail from "./components/region/RegionDetail";

import CountryList from "./components/country/CountryList";
import CountryDetail from "./components/country/CountryDetail";

import StockTransferRequestDetail from "./components/stock-transfer-request/StockTransferRequestDetail";
import StockTransferRequestList from "./components/stock-transfer-request/StockTransferRequestList";

import ConsignmentList from "./components/consignment/ConsignmentList";

import LocationMovementList from "./components/location-movement/LocationMovementList";
import LocationMovementDetail from "./components/location-movement/LocationMovementDetail";

import DamageList from "./components/damage/DamageList";
import DamageDetail from "./components/damage/DamageDetail";
import AccountReceivableList from "./components/accountreceivable/AccountReceivableList";
import AccountReceivableDetail from "./components/accountreceivable/AccountReceivableDetail";
import AccountReceivableAdvancedTypeReport from "./components/accountreceivable/AccountReceivableAdvancedTypeReport";

import AccountPayableDetail from "./components/accountpayable/accountpayabledetail/AccountPayableDetail";
import AccountPayableList from "./components/accountpayable/AccountPayableList";
import CustomerSaleReport from "./components/customer-sale-report/CustomerSaleReport";

import StockAnalysisReport from "./components/stock-analysis-report/StockAnalysisReport";
import CustomerStockAnalysisReport from "./components/stock-analysis-report/CustomerStockAnalysisReport";
import POStockReport from "./components/po-stock-report/POStockReport";
import DailySaleReport from "./components/dailysalereport/DailySaleReport";
import AccountPayableReport from "./components/account-payable-report/AccountPayableReport";

import SaleReportByCode from "./components/sale-report/SaleReportByCode";
import MonthlyStockAnalysisReport from "./components/monthly-stock-analysis-report/MonthlyStockAnalysisReport";
import SaleAnalysisReport from "./components/sale-analysis-report/SaleAnalysisReport";
import MonthlyCustomerSaleReport from "./components/monthly-customer-sale-report/MonthlyCustomerSaleReport";
import MonthlyCustomerSaleReportByCategoryGroup from "./components/monthly-customer-sale-report/MonthlyCustomerSaleReportByCategoryGroup";
import MonthlyStockAnalysisReportByCustomer from "./components/monthly-stock-analysis-report/MonthlyStockAnalysisReportByCustomer";
import MonthlyStockAnalysisReportByCity from "./components/monthly-stock-analysis-report/MonthlyStockAnalysisReportByCity";
import CashReceiptListingByDate from "./components/cash-receipt-listing-by-date/CashReceiptListingByDate";
import OutstandingInvoiceReport from "./components/outstanding-invoice-report/OutstandingInvoiceReport";
import CustomerProductSaleReport from "./components/customer-product-sale-report/CustomerProductSaleReport";

import AccountHeadList from "./components/accounthead/AccountHeadList";
import AccountHeadDetail from "./components/accounthead/AccountHeadDetail";
import AccountTypeList from "./components/account-type/AccountTypeList";
import AccountTypeDetail from "./components/account-type/AccountTypeDetail";
import ChartOfAccountDetail from "./components/chartofaccount/ChartOfAccountDetail";
import ChartOfAccountList from "./components/chartofaccount/ChartOfAccountList";
import GeneralLedgerList from "./components/general-ledger/GeneralLedgerList";
import GeneralLedgerDetail from "./components/general-ledger/GeneralLedgerDetail";

import TrialBalanceList from "./components/trial-balance/TrialBalanceList";
import TrialBalanceDetail from "./components/trial-balance/TrialBalanceDetail";
import ChashTrialBalance from "./components/trial-balance/ChashTrialBalance";
import DepartmentList from "./components/department/DepartmentList";
import DepartmentDetail from "./components/department/DepartmentDetail";
import OperationSettingList from "./components/operation-setting/OperationSettingList";
import OperationSettingDetail from "./components/operation-setting/OperationSettingDetail";
import LayoutSettingList from "./components/layout-setting/LayoutSettingList";
import LayoutSettingDetail from "./components/layout-setting/LayoutSettingDetail";
import IncomeStatementList from "./components/income-statement/IncomeStatementList";
import IncomeStatementPreview from "./components/income-statement/IncomeStatementPreview";
import MonthlyIncomeStatementDetail from "./components/income-statement/MonthlyIncomeStatementDetail";
import BalanceSheetList from "./components/balance-sheet/BalanceSheetList";
import BalanceSheetPreview from "./components/balance-sheet/BalanceSheetPreview";
import MonthlyBalanceSheetDetail from "./components/balance-sheet/MonthlyBalanceSheetDetail";
import FinanceSessionList from "./components/finance-session/FinanceSessionList";
import FinanceSessionDetail from "./components/finance-session/FinanceSessionDetail";
import FinanceSettingList from "./components/finance-setting/FinanceSettingList";
import FinanceSettingDetail from "./components/finance-setting/FinanceSettingDetail";
import GeneralJournalList from "./components/general-journal/GeneralJournalList";
import GeneralJournalDetail from "./components/general-journal/GeneralJournalDetail";
import GLListing from "./components/gl-listing/GLListing";
import AccountPayableReportBySupplier from "./components/account-payable-report/AccountPayableReportBySupplier";
import NetPurchaseReport from "./components/net-purchase-report/NetPurchaseReport";
import NetSaleReport from "./components/net-sale-report/NetSaleReport";
import AccountReceivableReportByCustomer from "./components/account-receivable-report-by-customer/AccountReceivableReportByCustomer";
import AccountPayableFinanceReport from "./components/account-payable-report/AccountPayableFinanceReport";
import AccountReceivableFinanceReport from "./components/account-receivable-report/AccountReceivableFinanceReport";
import CustomerSaleReportByCategory from "./components/customer-sale-report-by-category/CustomerSaleReportByCategory";
import AdvancedReport from "./components/advanced-report/AdvancedReport";
import SaleReportByCategory from "./components/sale-report/SaleReportByCategory";
import CategoryGroupList from "./components/category-group/CategoryGroupList";
import CategoryGroupDetail from "./components/category-group/CategoryGroupDetail";
import CustomerProductSaleReportByCategoryGroup from "./components/customer-product-sale-report-by-category-group/CustomerProductSaleReportByCategoryGroup";
import DailyCustomerSaleReportByCategoryGroup from "./components/daily-customer-sale-report-by-category-group/DailyCustomerSaleReportByCategoryGroup";
import CustomerSaleAnalysisReportByCategoryGroup from "./components/customer-sale-analysis-report/CustomerSaleAnalysisReportByCategoryGroup";
import DamageSaleApprovedReportByCategoryGroup from "./components/damage-sale-report-by-category-group/DamageSaleApprovedReportByCategoryGroup";
import DamageSaleNotApprovedReportByCategoryGroup from "./components/damage-sale-report-by-category-group/DamageSaleNotApprovedReportByCategoryGroup";
import OutstandingInvoiceReportByCategoryGroup from "./components/outstanding-invoice-report-by-category-group/OutstandingInvoiceReportByCategoryGroup";
import StockLedgerList from "./components/stock-ledger/StockLedgerList";
import SaleIssueList from "./components/sale-issue/SaleIssueList";
import SaleTeamList from "./components/sale-team/SaleTeamList";
import SaleTeamDetail from "./components/sale-team/SaleTeamDetail";
import EMRList from "./components/emr/EMRList";
import EMRDetail from "./components/emr/EMRDetail";
import RMRList from "./components/rmr/RMRList";
import RMRDetail from "./components/rmr/RMRDetail";
import AssetList from "./components/asset/AssetList";
import AssetDetail from "./components/asset/AssetDetail";
import CustomerSaleReportBySaleTeam from "./components/customer-sale-report-by-sale-team/CustomerSaleReportBySaleTeam";
import CustomerProductSaleReportBySaleTeam from "./components/customer-product-sale-report-by-sale-team/CustomerProductSaleReportBySaleTeam";
import ProductSaleReportBySaleTeam from "./components/product-sale-report-by-sale-team/ProductSaleReportBySaleTeam";
import CustomerCreditBalanceReport from "./components/customer-credit-balance-report/CustomerCreditBalanceReport";
import QCList from "./components/qc/QCList";
import QCDetail from "./components/qc/QCDetail";
import ProudctionOrderList from "./components/production-order/ProductionOrderList.vue";
import ProudctionOrderDetail from "./components/production-order/ProductionOrderDetial.vue";
import ManufacturingCostList from "./components/manufacturing-cost/ManufacturingCostList";
import ManufacturingCostDetail from "./components/manufacturing-cost/ManufacturingCostDetail";
import ProductionList from "./components/production/ProductionList";
import ProductionDetail from "./components/production/ProductionDetail";
import StoreReturnNoteList from "./components/store-return-note/StoreReturnNoteList";
import StoreReturnNoteDetail from "./components/store-return-note/StoreReturnNoteDetail";
import MaintenanceFrequencyList from "./components/maintenance-frequency/MaintenanceFrequencyList";
import MaintenanceFrequencyDetail from "./components/maintenance-frequency/MaintenanceFrequencyDetail";
import MaintenanceTypeList from "./components/maintenance-type/MaintenanceTypeList";
import MaintenanceTypeDetail from "./components/maintenance-type/MaintenanceTypeDetail";
import MachineTypeList from "./components/machine-type/MachineTypeList";
import MachineTypeDetail from "./components/machine-type/MachineTypeDetail";
import CheckListFrequencyList from "./components/check-list-frequency/CheckListFrequencyList";
import CheckListFrequencyDetail from "./components/check-list-frequency/CheckListFrequencyDetail";
import OrderSaleReport from "./components/order-sale-report/OrderSaleReport";
import StockBalanceSummaryList from "./components/stock-balance-summary/StockBalanceSummaryList.vue";
import BudgetList from "./components/budget/BudgetList";
import BudgetDetail from "./components/budget/BudgetDetail";
import MachineList from "./components/machine/MachineList";
import MachineDetail from "./components/machine/MachineDetail";
import ProcurementPlanList from "./components/procurement-plan/ProcurementPlanList.vue";
import ProcurementPlanDetail from "./components/procurement-plan/ProcurementPlanDetail.vue";
import ProcurementPlanAssetList from "./components/procurement-plan-asset/ProcurementPlanAssetList";
import ProcurementPlanAssetDetail from "./components/procurement-plan-asset/ProcurementPlanAssetDetail";
import ProcurementPlanReport from "./components/procurement-plan-report/ProcurementPlanReport";
import ProcurementPlanAssetReport from "./components/procurement-plan-asset-report/ProcurementPlanAssetReport";
import ProductionPlanList from "./components/production-plan/ProductionPlanList";
import ProductionPlanDetail from "./components/production-plan/ProductionPlanDetail";
import ProductionReport from "./components/production-report/ProductionReport";
import ProductionCostingList from "./components/production-costing/ProductionCostingList";
import ProductionCostingDetail from "./components/production-costing/ProductionCostingDetail";
import IncomeStatementByBranchPreview from "./components/income-statement/IncomeStatementByBranchPreview";
import AssetSummaryReport from "./components/asset-summary-report/AssetSummaryReport";
import AssetDetailReport from "./components/asset-detail-report/AssetDetailReport";
import ManufacturingAccountList from "./components/manufacturing-account/ManufacturingAccountList.vue";
import ManufacturingAccountPreview from "./components/manufacturing-account/ManufacturingAccountPreview.vue";
import ManufacturingAccountDetail from "./components/manufacturing-account/ManufacturingAccountDetail.vue";
import ProductionReportByCategory from "./components/production-report-by-category/ProductionReportByCategory";

Vue.use(Router);

export const router = new Router({
  routes: [
    { path: "/", redirect: "/dashboard" },
    { path: "/dashboard", name: "dashboard", component: Dashboard },

    { path: "/users", name: "users", component: UserList },
    { path: "/users/:id", name: "users-detail", component: UserDetail },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword,
    },

    { path: "/categories", name: "categories", component: CategoryList },

    {
      path: "/category/:id",
      name: "category-detail",
      component: CategoryDetail,
    },
    {
      path: "/brand/:id",
      name: "brand-detail",
      component: BrandDetail,
    },

    {
      path: "/brands",
      name: "brands",
      component: BrandList,
    },

    { path: "/units", name: "units", component: UnitList },
    {
      path: "/unit/:id",
      name: "unit-detail",
      component: UnitDetail,
    },

    {
      path: "/product-groups",
      name: "product-groups",
      component: ProductGroupList,
    },
    {
      path: "/product-group/:id",
      name: "product-group-detail",
      component: ProductGroupDetail,
    },

    {
      path: "/products",
      name: "products",
      component: ProductList,
    },
    {
      path: "/product/:id",
      name: "product-detail",
      component: ProductDetail,
    },

    {
      path: "/stock-transfers",
      name: "stock-transfers",
      component: StockTransferList,
    },
    {
      path: "/stock-transfer/:id",
      name: "stock-transfer-detail",
      component: StockTransferDetail,
    },

    {
      path: "/warehouse/:id",
      name: "warehouse-detail",
      component: WarehouseDetail,
    },

    { path: "/warehouses", name: "warehouses", component: WarehouseList },
    {
      path: "/stockin/:id",
      name: "stockin-detail",
      component: StockInDetail,
    },
    {
      path: "/stockins",
      name: "stockins",
      component: StockInList,
    },

    { path: "/taxs", name: "taxs", component: TaxList },
    { path: "/taxs/:id", name: "taxs-detail", component: TaxDetailList },

    {
      path: "/stock-adjustment/:id",
      name: "stock-adjustment-detail",
      component: StockAdjustmentDetail,
    },

    {
      path: "/stock-adjustments",
      name: "stock-adjustments",
      component: StockAdjustmentList,
    },

    {
      path: "/counter-cashs",
      name: "counter-cashs",
      component: CounterCashList,
    },

    {
      path: "/counter-cash/:id",
      name: "countercash-detail",
      component: CounterCashDetail,
    },

    {
      path: "/check-lists",
      name: "check-lists",
      component: CheckList,
    },

    {
      path: "/maintenance-schedules",
      name: "maintenance-schedules",
      component: MaintenanceScheduleList,
    },

    {
      path: "/stock-takes",
      name: "stock-takes",
      component: StockTakeList,
    },
    {
      path: "/stock-take-register",
      name: "stock-take-register",
      component: StockTakeRegister,
    },

    {
      path: "/stock-balances",
      name: "stock-balances",
      component: StockBalanceList,
    },

    {
      path: "/stock-balance-summary",
      name: "stock-balance-summary",
      component: StockBalanceSummaryList,
    },

    {
      path: "/stock-valuation-report",
      name: "stock-valuation-report",
      component: StockValuationReport,
    },

    {
      path: "/counter-cash-report",
      name: "counter-cash-report",
      component: CounterCashReport,
    },

    {
      path: "/sale-report",
      name: "sale-report",
      component: SaleReport,
    },
    {
      path: "/purchase-order-report",
      name: "purchase-order-report",
      component: PurchaseOrderReport,
    },
    {
      path: "/purchase-analysis-report",
      name: "purchase-analysis-report",
      component: PurchaseAnalysisReport,
    },
    {
      path: "/stock-transfer-report",
      name: "stock-transfer-report",
      component: StockTransferReport,
    },
    {
      path: "/damage-sale-approved-report",
      name: "damage-sale-approved-report",
      component: DamageSaleApprovedReport,
    },
    {
      path: "/damage-sale-not-approved-report",
      name: "damage-sale-not-approved-report",
      component: DamageSaleNotApprovedReport,
    },
    {
      path: "/way-sale-report",
      name: "way-sale-report",
      component: WaySaleReport,
    },

    {
      path: "/check-in-report",
      name: "check-in-report",
      component: CheckInReport,
    },

    {
      path: "/system-serializes",
      name: "system-serializes",
      component: SystemSerializeList,
    },

    {
      path: "/system-serialize/:id",
      name: "system-serialize-detail",
      component: SystemSerializeDetail,
    },

    {
      path: "/cash-in-hand-report",
      name: "cash-in-hand-report",
      component: CashInHandReport,
    },

    {
      path: "/preventive-maintenance-machine-report",
      name: "preventive-maintenance-machine-report",
      component: PreventiveMaintenanceMachineReport,
    },

    { path: "/shift-infos", name: "shift-infos", component: ShiftInfoList },
    {
      path: "/shift-info/:id",
      name: "shift-info-detail",
      component: ShiftInfoDetail,
    },

    { path: "/menu-report", name: "menu-report", component: MenuReport },

    {
      path: "/shift-assigns",
      name: "shift-assigns",
      component: ShiftAssignList,
    },
    {
      path: "/shift-assign/:id",
      name: "shift-assign-detail",
      component: ShiftAssignDetail,
    },
    { path: "/shops", name: "shops", component: ShopList },
    { path: "/shop/:id", name: "shop", component: ShopDetail },
    { path: "/letter-heads", name: "letter-heads", component: LetterHeadList },
    { path: "/letter-head/:id", name: "letter-head", component: LetterHeadDetail },
    { path: "/counters", name: "counters", component: CounterList },
    { path: "/counter/:id", name: "counter", component: CounterDetail },

    { path: "/currencies", name: "currencies", component: CurrencyList },
    { path: "/currency/:id", name: "currency", component: CurrencyDetail },

    {
      path: "/currency-exchange-rates",
      name: "currency-exchange-rates",
      component: CurrencyExchangeList,
    },
    {
      path: "/currency-exchange-rate/:id",
      name: "currency-exchange-rate",
      component: CurrencyExchangeDetail,
    },

    { path: "/sales", name: "sales", component: SaleList },

    { path: "/purchase-order", name: "purchase-order", component: PurchaseOrderList },
    { path: "/purchase-order/:id", name: "purchase-order-detail", component: PurchaseOrderDetail },
    { path: "/po-order", name: "purchase-order-order", component: PurchaseOrderOrder },
    { path: "/purchase-order-assets", name: "purchase-order-assets", component: PurchaseOrderAssetList },
    { path: "/purchase-order-asset/:id", name: "purchase-order-asset-detail", component: PurchaseOrderAssetDetail },

    {
      path: "/credit-level/:id",
      name: "credit-level-detail",
      component: CreditLevelDetail,
    },
    {
      path: "/credit-levels",
      name: "credit-levels",
      component: CreditLevelList,
    },

    {
      path: "/customer-credit-balance",
      name: "CustomerCreditBalance",
      component: CustomerCreditBalanceList,
    },

    {
      path: "/customer/:id",
      name: "customer-detail",
      component: CustomerDetail,
    },
    { path: "/customers", name: "customers", component: CustomerList },

    {
      path: "/production-item/:id",
      name: "production-item-detail",
      component: ProductionItemDetail,
    },
    {
      path: "/production-items",
      name: "production-items",
      component: ProductionItemList,
    },

    {
      path: "/supplier/:id",
      name: "supplier-detail",
      component: SupplierDetail,
    },
    { path: "/suppliers", name: "suppliers", component: SupplierList },

    {
      path: "/price-model/:id",
      name: "price-model-detail",
      component: PriceModelDetail,
    },
    { path: "/price-models", name: "price-models", component: PriceModelList },
    { path: "/sale-return", name: "sale-return", component: SaleReturn },

    {
      path: "/whole-sale/:id",
      name: "whole-sale-detail",
      component: WholeSaleDetail,
    },
    { path: "/whole-sales", name: "whole-sales", component: WholeSaleList },

    {
      path: "/credit-cash-flows",
      name: "CreditCashFlows",
      component: CreditCashFlowList,
    },

    {
      path: "/stock-issue/:id",
      name: "stock-issue-detail",
      component: StockIssueDetail,
    },
    { path: "/stock-issues", name: "stock-issues", component: StockIssueList },

    { path: "/cities", name: "cities", component: CityList },
    { path: "/city/:id", name: "city-detail", component: CityDetail },

    {
      path: "/customer-shops",
      name: "customer-shops",
      component: CustomerShopList,
    },
    {
      path: "/customer-shop/:id",
      name: "customer-shop-detail",
      component: CustomerShopDetail,
    },

    { path: "/way-assigns", name: "way-assigns", component: WayAssignList },
    {
      path: "/way-assign/:id",
      name: "way-assign-detail",
      component: WayAssignDetail,
    },

    { path: "/ways", name: "ways", component: WayList },
    { path: "/way/:id", name: "way-detail", component: WayDetail },

    {
      path: "/material-sessions",
      name: "material-sessions",
      component: MaterialSessionList,
    },
    {
      path: "/material-session/:id",
      name: "material-session-detail",
      component: MaterialSessionDetail,
    },

    {
      path: "/production-orders",
      name: "production-orders",
      component: ProudctionOrderList,
    },
    {
      path: "/production-order/:id",
      name: "production-order-detail",
      component: ProudctionOrderDetail,
    },

    {
      path: "/stock-templates",
      name: "stock-templates",
      component: StockTemplateList,
    },
    {
      path: "/stock-template/:id",
      name: "stock-template-detail",
      component: StockTemplateDetail,
    },

    { path: "/shop-types", name: "shop-types", component: ShopTypeList },
    {
      path: "/shop-type/:id",
      name: "shop-type-detail",
      component: ShopTypeDetail,
    },

    { path: "/bintypes", name: "bintypes", component: BinTypeList },
    { path: "/bintype/:id", name: "bintype-detail", component: BinTypeDetail },

    { path: "/bins", name: "bins", component: BinList },
    { path: "/bin/:id", name: "bin-detail", component: BinDetail },

    { path: "/branchs", name: "branchs", component: BranchList },
    { path: "/branch/:id", name: "branch-detail", component: BranchDetail },

    { path: "/countrys", name: "countrys", component: CountryList },
    {
      path: "/country/:id",
      name: "country-detail",
      component: CountryDetail,
    },

    {
      path: "/stock-transfer-requests",
      name: "stock-transfer-requests",
      component: StockTransferRequestList,
    },
    {
      path: "/stock-transfer-request/:id",
      name: "stock-transfer-request-detail",
      component: StockTransferRequestDetail,
    },

    { path: "/orders", name: "orders", component: OrderList },
    { path: "/order/:id", name: "order-detail", component: OrderDetail },

    { path: "/regions", name: "regions", component: RegionList },
    { path: "/region/:id", name: "region", component: RegionDetail },

    { path: "/consignments", name: "consignments", component: ConsignmentList },

    {
      path: "/location-movements",
      name: "location-movements",
      component: LocationMovementList,
    },
    {
      path: "/location-movement/:id",
      name: "location-movement-detail",
      component: LocationMovementDetail,
    },

    { path: "/damages", name: "damages", component: DamageList },
    { path: "/damage/:id", name: "damage-detail", component: DamageDetail },

    { path: "/production-plans", name: "production-plans", component: ProductionPlanList },
    { path: "/production-plan/:id", name: "production-plan", component: ProductionPlanDetail },

    {
      path: "/accountreceivables",
      name: "accountreceivables",
      component: AccountReceivableList,
    },
    {
      path: "/accountreceivable/:id",
      name: "accountreceivable",
      component: AccountReceivableDetail,
    },
    {
      path: "/account-receivable-advanced-type-report",
      name: "accountReceivableAdvancedTypeReport",
      component: AccountReceivableAdvancedTypeReport,
    },

    {
      path: "/accountpayables",
      name: "accountpayables",
      component: AccountPayableList,
    },
    {
      path: "/accountpayable/:id",
      name: "accountpayable",
      component: AccountPayableDetail,
    },

    {
      path: "/stock-analysis-report",
      name: "stock-analysis-report",
      component: StockAnalysisReport,
    },

    {
      path: "/customer-stock-analysis-report",
      name: "customer-stock-analysis-report",
      component: CustomerStockAnalysisReport,
    },

    {
      path: "/daily-sale-report",
      name: "daily-sale-report",
      component: DailySaleReport,
    },

    {
      path: "/po-stock-report",
      name: "po-stock-report",
      component: POStockReport,
    },

    {
      path: "/account-payable-report",
      name: "account-payable-report",
      component: AccountPayableReport,
    },

    {
      path: "/account-payable-report-by-supplier",
      name: "account-payable-report-by-supplier",
      component: AccountPayableReportBySupplier,
    },

    {
      path: "/customer-sale-report",
      name: "customer-sale-report",
      component: CustomerSaleReport,
    },

    {
      path: "/customer-sale-report-by-category",
      name: "customer-sale-report-by-category",
      component: CustomerSaleReportByCategory,
    },

    {
      path: "/sale-analysis-report",
      name: "sale-analysis-report",
      component: SaleAnalysisReport,
    },

    {
      path: "/sale-report-by-category",
      name: "sale-report-by-category",
      component: SaleReportByCategory,
    },

    {
      path: "/sale-report-by-code",
      name: "sale-report-by-code",
      component: SaleReportByCode,
    },
    {
      path: "/net-purchase-report",
      name: "net-purchase-report",
      component: NetPurchaseReport,
    },
    {
      path: "/net-sale-report",
      name: "net-sale-report",
      component: NetSaleReport,
    },
    {
      path: "/advanced-report",
      name: "advanced-report",
      component: AdvancedReport,
    },
    {
      path: "/monthly-stock-analysis-report",
      name: "monthly-stock-analysis-report",
      component: MonthlyStockAnalysisReport,
    },
    {
      path: "/monthly-stock-analysis-report-by-customer",
      name: "monthly-stock-analysis-report-by-customer",
      component: MonthlyStockAnalysisReportByCustomer,
    },
    {
      path: "/monthly-stock-analysis-report-by-city",
      name: "monthly-stock-analysis-report-by-city",
      component: MonthlyStockAnalysisReportByCity,
    },

    {
      path: "/monthly-customer-sale-report",
      name: "monthly-customer-sale-report",
      component: MonthlyCustomerSaleReport,
    },
    {
      path: "/monthly-customer-sale-report-by-category-group",
      name: "monthly-customer-sale-report-by-category-group",
      component: MonthlyCustomerSaleReportByCategoryGroup,
    },

    {
      path: "/cash-receipt-listing-by-date",
      name: "cash-receipt-listing-by-date",
      component: CashReceiptListingByDate,
    },
    {
      path: "/account-receivable-report-by-customer",
      name: "account-receivable-report-by-customer",
      component: AccountReceivableReportByCustomer,
    },
    {
      path: "/account-receivable-finance-report",
      name: "account-receivable-finance-report",
      component: AccountReceivableFinanceReport,
    },

    {
      path: "/outstanding-invoice-report",
      name: "outstanding-invoice-report",
      component: OutstandingInvoiceReport,
    },
    {
      path: "/customer-product-sale-report",
      name: "customer-product-sale-report",
      component: CustomerProductSaleReport,
    },

    { path: "/accountheads", name: "accountheads", component: AccountHeadList },
    {
      path: "/accounthead/:id",
      name: "accounthead",
      component: AccountHeadDetail,
    },

    {
      path: "/account-types",
      name: "account-types",
      component: AccountTypeList,
    },
    {
      path: "/account-type/:id",
      name: "account-type",
      component: AccountTypeDetail,
    },

    {
      path: "/chart-of-accounts",
      name: "chart-of-accounts",
      component: ChartOfAccountList,
    },
    {
      path: "/chart-of-account/:id",
      name: "chart-of-account",
      component: ChartOfAccountDetail,
    },

    {
      path: "/general-ledgers",
      name: "general-ledgers",
      component: GeneralLedgerList,
    },
    {
      path: "/general-ledger/:id",
      name: "general-ledger",
      component: GeneralLedgerDetail,
    },

    {
      path: "/general-journals",
      name: "general-journals",
      component: GeneralJournalList,
    },
    {
      path: "/general-journal/:id",
      name: "general-journal",
      component: GeneralJournalDetail,
    },

    {
      path: "/general-ledger-listing",
      name: "general-ledger-listing",
      component: GLListing,
    },

    {
      path: "/trial-balances",
      name: "trial-balances",
      component: TrialBalanceList,
    },
    {
      path: "/trial-balance/:id",
      name: "trial-balance",
      component: TrialBalanceDetail,
    },
    {
      path: "/cash-trial-balance",
      name: "cash-trial-balance",
      component: ChashTrialBalance,
    },

    {
      path: "/assets",
      name: "assets",
      component: AssetList,
    },
    {
      path: "/asset/:id",
      name: "asset",
      component: AssetDetail,
    },

    {
      path: "/operation-settings",
      name: "operation-settings",
      component: OperationSettingList,
    },
    {
      path: "/operation-setting/:id",
      name: "operation-setting",
      component: OperationSettingDetail,
    },

    {
      path: "/layout-settings",
      name: "layout-settings",
      component: LayoutSettingList,
    },
    {
      path: "/layout-setting/:id",
      name: "layout-setting",
      component: LayoutSettingDetail,
    },

    {
      path: "/income-statements",
      name: "income-statements",
      component: IncomeStatementList,
    },
    {
      path: "/income-statement-by-branch",
      name: "income-statement-by-branch",
      component: IncomeStatementByBranchPreview,
    },
    {
      path: "/income-statement/:id",
      name: "income-statement",
      component: MonthlyIncomeStatementDetail,
    },
    {
      path: "/income-statement-preview",
      name: "income-statement-preview",
      component: IncomeStatementPreview,
    },

    {
      path: "/balance-sheets",
      name: "balance-sheets",
      component: BalanceSheetList,
    },
    {
      path: "/balance-sheet/:id",
      name: "balance-sheet",
      component: MonthlyBalanceSheetDetail,
    },
    {
      path: "/balance-sheet-preview",
      name: "balance-sheet-preview",
      component: BalanceSheetPreview,
    },
    {
      path: "/finance-sessions",
      name: "finance-sessions",
      component: FinanceSessionList,
    },
    {
      path: "/finance-sessions/:id",
      name: "finance-session",
      component: FinanceSessionDetail,
    },
    {
      path: "/finance-settings",
      name: "finance-settings",
      component: FinanceSettingList,
    },
    {
      path: "/finance-setting/:id",
      name: "finance-setting",
      component: FinanceSettingDetail,
    },
    {
      path: "/account-payable-finance-report",
      name: "account-payable-finance-report",
      component: AccountPayableFinanceReport,
    },

    {
      path: "/category-groups",
      name: "category-groups",
      component: CategoryGroupList,
    },
    {
      path: "/category-group/:id",
      name: "category-group",
      component: CategoryGroupDetail,
    },

    {
      path: "/customer-product-sale-report-by-category-group",
      name: "customer-product-sale-report-by-category-group",
      component: CustomerProductSaleReportByCategoryGroup,
    },
    {
      path: "/daily-customer-sale-report-by-category-group",
      name: "daily-customer-sale-report-by-category-group",
      component: DailyCustomerSaleReportByCategoryGroup,
    },
    {
      path: "/customer-sale-analysis-report-by-category-group",
      name: "customer-sale-analysis-report-by-category-group",
      component: CustomerSaleAnalysisReportByCategoryGroup,
    },

    {
      path: "/damage-sale-approved-report-by-category-group",
      name: "damage-sale-approved-by-category-group",
      component: DamageSaleApprovedReportByCategoryGroup,
    },
    {
      path: "/damage-sale-not-approved-report-by-category-group",
      name: "damage-sale-not-approved-by-category-group",
      component: DamageSaleNotApprovedReportByCategoryGroup,
    },

    {
      path: "/outstanding-invoice-report-by-category-group",
      name: "outstanding-invoice-report-by-category-group",
      component: OutstandingInvoiceReportByCategoryGroup,
    },

    {
      path: "/stock-ledgers",
      name: "stock-ledgers",
      component: StockLedgerList,
    },

    { path: "/sale-issue", name: "sale-issue", component: SaleIssueList },

    { path: "/sale-teams", name: "sale-teams", component: SaleTeamList },
    { path: "/sale-team/:id", name: "sale-team", component: SaleTeamDetail },

    { path: "/emrs", name: "emrs", component: EMRList },
    { path: "/emr/:id", name: "emr", component: EMRDetail },

    { path: "/rmrs", name: "rmrs", component: RMRList },
    { path: "/rmr/:id", name: "rmr", component: RMRDetail },

    { path: "/departments", name: "departments", component: DepartmentList },
    {
      path: "/department/:id",
      name: "department",
      component: DepartmentDetail,
    },

    {
      path: "/customer-sale-report-by-sale-team",
      name: "customer-sale-report-by-sale-team",
      component: CustomerSaleReportBySaleTeam,
    },

    {
      path: "/customer-product-sale-report-by-sale-team",
      name: "customer-product-sale-report-by-sale-team",
      component: CustomerProductSaleReportBySaleTeam,
    },

    {
      path: "/product-sale-report-by-sale-team",
      name: "product-sale-report-by-sale-team",
      component: ProductSaleReportBySaleTeam,
    },

    {
      path: "/customer-credit-balance-report",
      name: "customer-credit-balance-report",
      component: CustomerCreditBalanceReport,
    },

    { path: "/qcs", name: "qcs", component: QCList },
    { path: "/qc/:id", name: "qc", component: QCDetail },

    { path: "/manufacturing-costs", name: "manufacturing-costs", component: ManufacturingCostList },
    { path: "/manufacturing-cost/:id", name: "manufacturing-cost", component: ManufacturingCostDetail },

    { path: "/productions", name: "productions", component: ProductionList },
    { path: "/production/:id", name: "production", component: ProductionDetail },

    { path: "/store-return-notes", name: "store-return-notes", component: StoreReturnNoteList },
    { path: "/store-return-note/:id", name: "store-return-note", component: StoreReturnNoteDetail },

    { path: "/maintenance-frequencys", name: "maintenance-frequencys", component: MaintenanceFrequencyList },
    { path: "/maintenance-frequency/:id", name: "maintenance-frequency", component: MaintenanceFrequencyDetail },

    { path: "/maintenance-types", name: "maintenance-types", component: MaintenanceTypeList },
    { path: "/maintenance-type/:id", name: "maintenance-type", component: MaintenanceTypeDetail },

    { path: "/machine-types", name: "machine-types", component: MachineTypeList },
    { path: "/machine-type/:id", name: "machine-type", component: MachineTypeDetail },

    { path: "/check-list-frequencys", name: "check-list-frequencys", component: CheckListFrequencyList },
    { path: "/check-list-frequency/:id", name: "check-list-frequency", component: CheckListFrequencyDetail },

    {
      path: "/order-sale-report",
      name: "order-sale-report",
      component: OrderSaleReport,
    },

    { path: "/procurement-plan-report", name: "procurement-plan-report", component: ProcurementPlanReport },
    { path: "/procurement-plan-asset-report", name: "procurement-plan-asset-report", component: ProcurementPlanAssetReport },
    { path: "/asset-summary-report", name: "asset-summary-report", component: AssetSummaryReport },
    { path: "/asset-detail-report", name: "asset-detail-report", component: AssetDetailReport },

    { path: "/budgets", name: "budgets", component: BudgetList },
    { path: "/budget/:id", name: "budget", component: BudgetDetail },
    { path: "/machines", name: "machines", component: MachineList },
    { path: "/machine/:id", name: "machine", component: MachineDetail },
    { path: "/procurement-plans", name: "procurement-plans", component: ProcurementPlanList },
    { path: "/procurement-plan/:id", name: "procurement-plan", component: ProcurementPlanDetail },
    { path: "/procurement-plan-assets", name: "procurement-plan-assets", component: ProcurementPlanAssetList },
    { path: "/procurement-plan-asset/:id", name: "procurement-plan-asset", component: ProcurementPlanAssetDetail },
    {
      path: "/production-report",
      name: "production-report",
      component: ProductionReport,
    },
    {
      path: "/production-costings",
      name: "production-costings",
      component: ProductionCostingList,
    },
    {
      path: "/production-costing/:id",
      name: "production-costing",
      component: ProductionCostingDetail,
    },

    { path: "/manufacturing-accounts", name: "manufacturing-accounts", component: ManufacturingAccountList },
    { path: "/manufacturing-account/:id", name: "manufacturing-account", component: ManufacturingAccountDetail },
    { path: "/manufacturing-account-preview", name: "manufacturing-account-preview", component: ManufacturingAccountPreview },

    { path: "/production-report-by-category", name: "production-report-by-category", component: ProductionReportByCategory },

    { path: "/login", name: "login", component: Login },

    { path: "*", redirect: "/" }, // otherwise redirect to home
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("accessToken");

  if (authRequired && !loggedIn) {
    return next("/login");
  } else if (!authRequired && loggedIn) {
    return next("/"); //prevent login reloading event
  }

  next();
});
